import React from "react";
import { FraudmeterContainer } from "./Fraudmeter.styles";

const Fraudmeter = ({
  value,
  percentage,
  title,
  subtitle,
  threshold,
}) => {
  console.log(value);
  if (value === null || value === undefined) {
    percentage = -170;
  }

  const renderColor = (value) => {
    if (value === null || value === undefined) {
      return "E2E2E2";
    }
    if (value <= 0.7) {
      return "#E16408";
    }
    return "#00ABAB";
  };

  const renderLabel = (value) => {
    if (title === "FACE MATCH") {
      if (value === null || value === undefined) {
        return "USER NOT FOUND";
      }
      if (value < 0.75) {
        return "NOT MATCHED";
      }
      return "MATCHED";
    }
    if (value === null || value === undefined) {
      return "NOT AVAILABLE";
    }
    if (value < 0.75) {
      return "FAILED";
    }
    return "LIVE PERSON";
  };
  const renderSubtitleColor = (value) => {
    if (value === "id_image") {
      return "#E16408";
    }
    return "#00ABAB";
  };

  return (
    <FraudmeterContainer>
      {subtitle && value ? (
        <>
          <h3 style={{ marginBottom: 0 }} className="title">
            {title}
          </h3>
          <div style={{ marginBottom: 0 }} className="subtitle">
            <span>with </span>
            <span style={{ color: renderSubtitleColor(subtitle) }}>
              {subtitle}
            </span>
          </div>
        </>
      ) : (
        <h3 className="title">{title}</h3>
      )}
      <div className="fraudmeter">
        <svg
          id="meter"
          style={{ transform: `rotate(${percentage}deg)` }}
          width="220"
          height="220"
          viewBox="0 0 220 220"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.31736 109.888C3.77272 109.892 0.0534291 106.205 0.390134 101.673C2.3287 75.5792 13.547 50.9312 32.1614 32.2867C52.7208 11.6941 80.6186 0.112058 109.717 0.088569C138.816 0.0650796 166.733 11.602 187.325 32.1614C205.97 50.7758 217.228 75.4058 219.209 101.496C219.553 106.028 215.839 109.72 211.295 109.724C206.75 109.728 203.101 106.039 202.697 101.512C200.758 79.7922 191.252 59.3374 175.697 43.8081C158.194 26.3326 134.465 16.5262 109.731 16.5462C84.9967 16.5661 61.2836 26.4109 43.8081 43.9146C28.2788 59.4689 18.8056 79.9391 16.9021 101.662C16.5055 106.189 12.862 109.884 8.31736 109.888Z"
            fill={renderColor(value)}
          />
          <circle
            cx="211.083"
            cy="101.007"
            r="6"
            transform="rotate(-0.0462445 211.083 101.007)"
            fill="white"
          />
        </svg>
        <svg
          id="mask"
          width="219"
          height="110"
          viewBox="0 0 219 110"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M109.717 0H0V110H219V103.555C218.281 107.094 215.038 109.717 211.206 109.717C206.661 109.717 203.015 106.026 202.615 101.499C200.694 79.7771 191.204 59.3146 175.662 43.7728C158.172 26.2832 134.451 16.4576 109.717 16.4576C84.9834 16.4576 61.2624 26.2832 43.7728 43.7728C28.231 59.3146 18.7412 79.7772 16.8203 101.499C16.4199 106.026 12.7734 109.717 8.22882 109.717C3.68414 109.717 -0.0321655 106.028 0.308228 101.496C2.26782 75.404 13.506 50.765 32.1355 32.1355C52.7115 11.5595 80.6186 0 109.717 0ZM109.717 0C138.816 0 166.723 11.5595 187.299 32.1355C205.562 50.3976 216.721 74.4347 219 99.9545V0H109.717Z"
            fill="white"
          />
        </svg>
      </div>
      {value === null || value === undefined ? (
        <h3 className="not-found">{renderLabel(value)}</h3>
      ) : (
        <>
          <h3 className="value">{value?.toFixed(1) ?? "N/A"}</h3>
          <small>Threshold: {threshold ? threshold.toFixed(2) : "0.70"}</small>
          <h3 style={{ color: renderColor(value) }}>{renderLabel(value)}</h3>
        </>
      )}
    </FraudmeterContainer>
  );
};

export default Fraudmeter;
